import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import LoadingButton from "../../../../components/Loading/LoadingButton";
import { postRequestByAuth } from "../../../../function/helper";
import SearchCity from "../../../../modules/public/quickPrice/components/SearchCity";
import BetterCheckbox from "./BetterCheckbox";
import DefaultAddressInfo from "./DefaultAddressInfo";
import formatMoney from "./formatMoney";
import formEnterToTab from "./formEnterToTab";
import getPackages from "./getPackages";
import OrderGetPriceModal from "./OrderGetPriceModal";

export default function OrderForm({
  getSellerData,
  order,
  postData,
  refetch,
  onClose,
}) {
  const [pricesData, setPricesData] = useState(undefined);
  const [orderPayload, setOrderPayload] = useState(undefined);
  const [openGetPrice, setOpenGetPrice] = useState(false);

  let parcelValue = 0;
  let parcelTitle = "";

  const eachTitleLength = parseInt(255 / order.variants.length);

  order.variants?.map(variant => {
    parcelValue += Number(variant?.price) * Number(variant?.count);
    parcelTitle += variant.title.slice(0, eachTitleLength);
  });

  const { control, handleSubmit, watch } = useForm({
    defaultValues: {
      parcelValue: parcelValue,
      needPackaging: false,
      needSMS: false,
      needPrint: false,
      isLiquid: false,
      isFragile: false,
      collectingType: "",
      packaging: "",
      weight: Number(postData?.weight) < 0.05 ? 0.05 : postData?.weight || "",
      dest_cityId: "",
      dest_name: order.customer_name
        ? order.customer_name.split(" ")[0] || ""
        : "",
      dest_family: order.customer_name
        ? order.customer_name.split(" ").slice(1).join(" ") || ""
        : "",
      dest_mobile: order.customer_phone_number || "",
      dest_postCode: order.customer_postal_code || "",
      dest_address: order.customer_address || "",
    },
  });

  const { isPending, mutate: mutateGetPrice } = useMutation({
    mutationKey: ["GetPrice"],
    mutationFn: payload =>
      postRequestByAuth("/v2/digikala/order/price", payload).then(res => {
        if (res && res.status === 200) {
          setPricesData(res?.data);
          setOpenGetPrice(true);

          return;
        }

        Swal.fire({
          icon: "error",
          text: res.message,
          showConfirmButton: true,
          confirmButtonText: "متوجه شدم",
        });
      }),
  });

  function cleanFormData(data) {
    const payload = {
      source: {
        cityId: Number(getSellerData?.seller?.defaultAddress?.city?.id),
      },
      destination: {
        cityId: Number(data?.dest_cityId),

        name: order?.customer_name
          ? order?.customer_name?.split(" ")[0] || ""
          : "",
        family: order?.customer_name
          ? order?.customer_name?.split(" ").slice(1).join(" ") || ""
          : "",
        mobile: order?.customer_phone_number || "",
        postCode: order?.customer_postal_code || "",
        address: data?.dest_address || "",
      },
      agentId: data?.agentId ? Number(data?.agentId) : undefined,
      methodPayment: 1,
      serviceId: 5,
      collectingType: Number(data.collectingType),
      parcel: {
        weight: Number(data?.weight || 0.05),
        length: Number(getPackages[Number(data.packaging || 0)]?.length || 0),
        width: Number(getPackages[Number(data.packaging || 0)]?.width || 0),
        height: Number(getPackages[Number(data.packaging || 0)]?.height || 0),
        parcelValue: Number(parcelValue),
        amountCOD: 0,
        packageTypeId: Number(
          getPackages[Number(data.packaging || 0)]?.type || 1
        ),
        needPackaging: !!data.needPackaging,
        isFragile: !!data.isFragile,
        isLiquid: !!data.isLiquid,
        content: parcelTitle,
      },
      needSMS: !!data.needSMS,
      needPrint: !!data.needPrint,
      order_shipment_id: order?.shipmentId,
    };
    return payload;
  }

  const onSubmit = data => {
    if (!isPending) {
      const payload = cleanFormData(data);
      setOrderPayload(payload);

      mutateGetPrice(payload);
    }
  };

  return (
    <>
      <div className="border rounded p-2 m-1">
        <h5 className="mb-3">اطلاعات مرسوله</h5>

        <form onKeyDown={formEnterToTab} onSubmit={handleSubmit(onSubmit)}>
          <div className="form-row row px-2">
            <div className="form-group col-12 col-sm-6 p-1">
              <Controller
                name="needSMS"
                control={control}
                render={({ field }) => (
                  <BetterCheckbox label="نیاز به ارسال پیامک" field={field} />
                )}
              />
            </div>

            <div className="form-group col-12 col-sm-6 p-1">
              <Controller
                name="isLiquid"
                control={control}
                render={({ field }) => (
                  <BetterCheckbox label="آیا مرسوله مایع است؟" field={field} />
                )}
              />
            </div>

            <div className="form-group col-12 col-sm-6 p-1">
              <Controller
                name="isFragile"
                control={control}
                render={({ field }) => (
                  <BetterCheckbox
                    label="آیا مرسوله شکستنی است؟"
                    field={field}
                  />
                )}
              />
            </div>
            <div className="form-group col-12"></div>

            <div className="form-group col-12 col-sm-6 p-1">
              <label className="pb-1">
                نوع بسته بندی کل مرسوله <span className="text-danger">*</span>
              </label>
              <Controller
                name="packaging"
                control={control}
                rules={{
                  required: "بسته بندی الزامی است",
                }}
                render={({ field: { onChange, value, ref }, fieldState }) => (
                  <>
                    <select
                      ref={ref}
                      className="form-control"
                      value={value}
                      onChange={e => onChange(e.target.value)}
                    >
                      <option value="">انتخاب کنید</option>
                      {getPackages.map((p, i) => (
                        <option key={i} value={i}>
                          {p.type === 6
                            ? `(${p.width}×${p.length}) پاکت ${p.title}`
                            : `(${p.height}×${p.width}×${p.length}) کارتن ${p.title}`}
                        </option>
                      ))}
                    </select>

                    {fieldState?.error && (
                      <div className="text-danger p-1 small">
                        {fieldState?.error?.message}
                      </div>
                    )}
                  </>
                )}
              />
            </div>

            <div className="form-group col-12 col-sm-6 p-1">
              <label className="pb-1">
                ارزش مرسوله (﷼)<span className="text-danger">*</span>
              </label>
              <Controller
                name="parcelValue"
                readOnly={true}
                control={control}
                rules={{
                  required: "ارزش مرسوله الزامی است",
                }}
                render={({ field: { value, ref }, fieldState }) => (
                  <>
                    <input
                      ref={ref}
                      type="text"
                      className="form-control"
                      value={formatMoney(value)}
                      disabled
                      readOnly
                    />

                    {fieldState?.error && (
                      <div className="text-danger p-1 small">
                        {fieldState?.error?.message}
                      </div>
                    )}
                  </>
                )}
              />
            </div>

            <div className="form-group col-12 col-sm-6 p-1">
              <label className="pb-1">
                وزن (کیلوگرم)<span className="text-danger">*</span>
              </label>
              <Controller
                name="weight"
                control={control}
                rules={{
                  required: "وزن الزامی است",
                  min: {
                    value: 0.05,
                    message:
                      "حداقل وزن میتواند 0.05 کیلو گرم معادل 50 گرم باشد الزامی",
                  },
                }}
                render={({ field: { onChange, value, ref }, fieldState }) => (
                  <>
                    <input
                      ref={ref}
                      type="number"
                      className="form-control"
                      value={value}
                      onChange={e => onChange(e.target.value)}
                    />

                    {fieldState?.error && (
                      <div className="text-danger p-1 small">
                        {fieldState?.error?.message}
                      </div>
                    )}
                  </>
                )}
              />
            </div>
          </div>

          <hr />

          <h5 className="mb-3">خدمات</h5>

          <div className="form-row row px-2">
            <div className="form-group col-12 col-sm-6 p-1">
              <label className="pb-1">
                روش جمع آوری <span className="text-danger">*</span>
              </label>
              <Controller
                name="collectingType"
                control={control}
                rules={{
                  required: "روش جمع آوری الزامی است",
                }}
                render={({ field: { onChange, value, ref }, fieldState }) => (
                  <>
                    <select
                      ref={ref}
                      className="form-control"
                      value={value}
                      onChange={e => onChange(e.target.value)}
                    >
                      <option value="">انتخاب کنید</option>
                      {getSellerData?.collectingTypes?.map(
                        (collectingType, i) => {
                          return (
                            <option
                              key={i}
                              value={collectingType?.id}
                              disabled={
                                collectingType?.isActive === 1 ? false : true
                              }
                            >
                              {collectingType?.name}
                            </option>
                          );
                        }
                      )}
                    </select>

                    {fieldState?.error && (
                      <div className="text-danger p-1 small">
                        {fieldState?.error?.message}
                      </div>
                    )}
                  </>
                )}
              />
            </div>

            <div className="form-group col-12"></div>
            <div className="form-group col-12 col-sm-6 p-1">
              <Controller
                name="needPackaging"
                control={control}
                disabled={Number(watch("collectingType")) === 1 ? false : true}
                render={({ field }) => (
                  <BetterCheckbox
                    label="نیاز به بسته‌بندی"
                    field={field}
                    checked={
                      Number(watch("collectingType")) === 1
                        ? Boolean(field.value)
                        : false
                    }
                    disabled={
                      Number(watch("collectingType")) === 1 ? false : true
                    }
                  />
                )}
              />
            </div>

            <div className="form-group col-12 col-sm-6 p-1">
              <Controller
                name="needPrint"
                control={control}
                disabled={Number(watch("collectingType")) === 1 ? false : true}
                render={({ field }) => (
                  <BetterCheckbox
                    label="نیاز به پرینت"
                    field={field}
                    checked={
                      Number(watch("collectingType")) === 1
                        ? Boolean(field.value)
                        : false
                    }
                    disabled={
                      Number(watch("collectingType")) === 1 ? false : true
                    }
                  />
                )}
              />
            </div>

            {!Number(watch("collectingType")) &&
              !getSellerData?.seller?.agent && (
                <div className="form-group col-12 p-1">
                  <p className="m-0 alert alert-warning">
                    برای دریافت خدمات بسته بندی و یا پرینت فاکتور نیاز است که
                    نوع جمع آوری (تمامی مراحل جمع آوری توسط نماینده انجام شود)
                    انتخاب شود و همچنین لازم است نماینده ای به فروشگاه شما تخصیص
                    داده شود، لطفا برای اتصال نماینده با پشتیبانی تماس بگیرید
                  </p>
                </div>
              )}
          </div>
          <hr />

          <h5 className="mb-3">اطلاعات فرستنده</h5>

          <div className="form-row row px-2">
            {getSellerData?.seller?.defaultAddressId ? (
              <DefaultAddressInfo getSellerData={getSellerData} />
            ) : (
              <p className="alert alert-danger">
                برای ثبت مرسوله ابتدا لازم است تا با رفتن به صفحه اطلاعات آدرس
                پیشفرض خود را مشخص نمایید
              </p>
            )}
          </div>

          <hr />

          <h5 className="mb-3">اطلاعات گیرنده</h5>

          <div className="form-row row px-2 pb-2">
            <div className="form-group col-12 p-1">
              <p>
                استان گیرنده دریافتی از دیجی‌کالا:{" "}
                <span className="text-dark fw-bold">
                  {order.address?.state}
                </span>
              </p>
              <p>
                شهر گیرنده دریافتی از دیجی‌کالا:{" "}
                <span className="text-dark fw-bold">{order.address?.city}</span>
              </p>

              <p className="m-0 alert alert-info">
                در این قسمت لازم است تا استان و شهر دریافتی از دیجی‌کالا را
                بررسی کنید و شهر معادل را جستجو و انتخاب کنید.
              </p>
            </div>

            <div className="form-group col-12 col-sm-6 p-1">
              <label className="pb-1">
                شهر <span className="text-danger">*</span>
              </label>

              <Controller
                name="dest_cityId"
                control={control}
                rules={{
                  required: "شهر الزامی است",
                }}
                render={({ field: { onChange }, fieldState }) => (
                  <>
                    <SearchCity onChoose={cityId => onChange(cityId)} />

                    {fieldState?.error && (
                      <div className="text-danger p-1 small">
                        {fieldState?.error?.message}
                      </div>
                    )}
                  </>
                )}
              />
            </div>

            <div className="form-group col-12 col-sm-6 p-1">
              <label className="pb-1">
                نام <span className="text-danger">*</span>
              </label>
              <Controller
                name="dest_name"
                control={control}
                readOnly={true}
                rules={{
                  required: "نام الزامی است",
                }}
                render={({ field: { onChange, value }, fieldState }) => (
                  <>
                    <input
                      type="text"
                      className="form-control"
                      value={value}
                      onChange={e => onChange(e.target.value)}
                      disabled
                      readOnly
                    />

                    {fieldState?.error && (
                      <div className="text-danger p-1 small">
                        {fieldState?.error?.message}
                      </div>
                    )}
                  </>
                )}
              />
            </div>

            <div className="form-group col-12 col-sm-6 p-1">
              <label className="pb-1">
                نام خانوادگی <span className="text-danger">*</span>
              </label>
              <Controller
                name="dest_family"
                control={control}
                readOnly={true}
                rules={{
                  required: " نام خانوادگی الزامی است",
                }}
                render={({ field: { onChange, value }, fieldState }) => (
                  <>
                    <input
                      type="text"
                      className="form-control"
                      value={value}
                      onChange={e => onChange(e.target.value)}
                      disabled
                      readOnly
                    />

                    {fieldState?.error && (
                      <div className="text-danger p-1 small">
                        {fieldState?.error?.message}
                      </div>
                    )}
                  </>
                )}
              />
            </div>

            <div className="form-group col-12 col-sm-6 p-1">
              <label className="pb-1">
                تلفن همراه <span className="text-danger">*</span>
              </label>
              <Controller
                name="dest_mobile"
                control={control}
                readOnly={true}
                rules={{
                  required: " تلفن همراه الزامی است",
                }}
                render={({ field: { onChange, value }, fieldState }) => (
                  <>
                    <input
                      type="text"
                      className="form-control"
                      value={value}
                      onChange={e => onChange(e.target.value)}
                      disabled
                      readOnly
                    />

                    {fieldState?.error && (
                      <div className="text-danger p-1 small">
                        {fieldState?.error?.message}
                      </div>
                    )}
                  </>
                )}
              />
            </div>

            <div className="form-group col-12 col-sm-6 p-1">
              <label className="pb-1">
                کد پستی <span className="text-danger">*</span>
              </label>
              <Controller
                name="dest_postCode"
                control={control}
                readOnly={true}
                rules={{
                  required: " کد پستی الزامی است",
                }}
                render={({ field: { onChange, value }, fieldState }) => (
                  <>
                    <input
                      type="text"
                      className="form-control"
                      value={value}
                      onChange={e => onChange(e.target.value)}
                      disabled
                      readOnly
                    />

                    {fieldState?.error && (
                      <div className="text-danger p-1 small">
                        {fieldState?.error?.message}
                      </div>
                    )}
                  </>
                )}
              />
            </div>

            <div className="form-group col-12 p-1">
              <label className="pb-1">
                آدرس <span className="text-danger">*</span>
              </label>
              <Controller
                name="dest_address"
                control={control}
                rules={{
                  required: "آدرس الزامی است",
                }}
                render={({ field: { onChange, value, ref }, fieldState }) => (
                  <>
                    <input
                      ref={ref}
                      type="text"
                      className="form-control"
                      value={value}
                      onChange={e => onChange(e.target.value)}
                    />

                    {fieldState?.error && (
                      <div className="text-danger p-1 small">
                        {fieldState?.error?.message}
                      </div>
                    )}
                  </>
                )}
              />
            </div>
          </div>

          {isPending && (
            <LoadingButton
              center
              className="btn-success"
              title="در حال استعلام"
            />
          )}

          {!isPending && (
            <Button
              variant="primary"
              disabled={isPending}
              type="submit"
              className="btn-success"
            >
              <span>استعلام هزینه ارسال</span>
            </Button>
          )}
        </form>
      </div>

      {pricesData && (
        <OrderGetPriceModal
          getSellerData={getSellerData}
          pricesData={pricesData}
          orderPayload={orderPayload}
          open={openGetPrice}
          onClose={() => {
            setOpenGetPrice(false);
          }}
          onCloseAll={() => {
            setOpenGetPrice(false);
            onClose();
          }}
          messages={pricesData?.errors}
          refetch={() => {
            refetch();
          }}
        />
      )}
    </>
  );
}
